!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define("React-Piwik", [], e) : "object" == typeof exports ? exports["React-Piwik"] = e() : t["React-Piwik"] = e();
}("undefined" != typeof self ? self : this, function () {
  return function (t) {
    function e(n) {
      if (i[n]) return i[n].exports;
      var o = i[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return t[n].call(o.exports, o, o.exports, e), o.l = !0, o.exports;
    }

    var i = {};
    return e.m = t, e.c = i, e.d = function (t, i, n) {
      e.o(t, i) || Object.defineProperty(t, i, {
        configurable: !1,
        enumerable: !0,
        get: n
      });
    }, e.n = function (t) {
      var i = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return e.d(i, "a", i), i;
    }, e.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, e.p = "", e(e.s = 0);
  }([function (t, e, i) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var n = function () {
      function t(t, e) {
        for (var i = 0; i < e.length; i++) {
          var n = e[i];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
        }
      }

      return function (e, i, n) {
        return i && t(e.prototype, i), n && t(e, n), e;
      };
    }(),
        o = function () {
      function t(e) {
        !function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, t);
        var i = e;
        if (i.enableLinkTracking = void 0 === i.enableLinkTracking || i.enableLinkTracking, i.trackDocumentTitle = void 0 === i.trackDocumentTitle || i.trackDocumentTitle, i.jsFilename = void 0 !== i.jsFilename ? i.jsFilename : "piwik.js", i.phpFilename = void 0 !== i.phpFilename ? i.phpFilename : "piwik.php", this.options = i, this.previousPath = null, void 0 === this.options.url || void 0 === this.options.siteId) throw new Error("PiwikTracker cannot be initialized! SiteId and url are mandatory.");
        this.initPiwik();
      }

      return n(t, [{
        key: "initPiwik",
        value: function value() {
          if ("undefined" != typeof window) {
            var e = this.options.url;
            -1 !== e.indexOf("http://") || -1 !== e.indexOf("https://") ? e += "/" : e = "https:" === document.location.protocol ? "https://" + e + "/" : "http://" + e + "/", window._paq = window._paq || [], t.push(["setSiteId", this.options.siteId]), t.push(["setTrackerUrl", "" + (e + this.options.phpFilename)]), this.options.enableLinkTracking && t.push(["enableLinkTracking"]);
            var i = document.createElement("script"),
                n = document.getElementsByTagName("script")[0];
            i.type = "text/javascript", i.defer = !0, i.async = !0;
            var o = this.options.jsFilename;
            0 !== o.indexOf("http://") && 0 !== o.indexOf("https://") && (o = e + o), i.src = o, n.parentNode.insertBefore(i, n);
          }

          return {
            push: this.push,
            track: this.track,
            connectToHistory: this.connectToHistory,
            disconnectFromHistory: this.disconnectFromHistory
          };
        }
      }, {
        key: "connectToHistory",
        value: function value(t, e) {
          var i = this,
              n = void 0 === t.getCurrentLocation ? t.location : t.getCurrentLocation();
          return e && this.track(n.path || (n.pathname + n.search).replace(/^\//, "")), this.unlistenFromHistory = t.listen(function (t) {
            i.track(t);
          }), t;
        }
      }, {
        key: "disconnectFromHistory",
        value: function value() {
          return !!this.unlistenFromHistory && (this.unlistenFromHistory(), !0);
        }
      }, {
        key: "getBasePath",
        value: function value() {
          return void 0 !== this.options.pathBasename ? window.location.origin + "/" + this.options.pathBasename + "/" : window.location.origin + "/";
        }
      }, {
        key: "track",
        value: function value(e) {
          if ("undefined" != typeof window) {
            var i = e.path || (e.pathname + e.search).replace(/^\//, "");
            this.previousPath !== i && (this.options.trackDocumentTitle && t.push(["setDocumentTitle", document.title]), this.previousPath && t.push(["setReferrerUrl", "" + this.getBasePath() + this.previousPath]), t.push(["setCustomUrl", "" + this.getBasePath() + i]), t.push(["trackPageView"]), this.previousPath = i);
          }
        }
      }], [{
        key: "push",
        value: function value(t) {
          window._paq.push(t);
        }
      }]), t;
    }();

    e.default = o, t.exports = e.default;
  }]);
});